export const enviorment = {
    // mode : 'dev' // dev | dist | demo
    // mode : 'demo' // dev | dist | demo
    mode : 'dist' // dev | dist | demo
}


// WEBPACK FOOTER //
// ./src/enviorment.ts